import { InfoOutlined } from '@mui/icons-material'
import { Button, IconButton, Link, Stack, Tooltip, Typography } from '@mui/joy'
import { DOCUMENTATION_ROUTE } from 'app/constants/route'
import { useNavigate } from 'react-router-dom'

type Props = {
  useIconButton?: boolean
}

const MoreInfoButton = ({ useIconButton }: Props) => {
  const navigate = useNavigate()
  const handleOnClick = () => {
    navigate(DOCUMENTATION_ROUTE)
  }
  return (
    <Tooltip title='Check the guidelines before you start!'>
      {
        useIconButton ?
          <IconButton
            onClick={handleOnClick}
            component="a"
            variant="plain"
            color="neutral"
          >
            <InfoOutlined />
            <Typography ml={1}>More Info</Typography>
          </IconButton>
          :
          <Button
            onClick={handleOnClick}
            variant='outlined'
            startDecorator={<InfoOutlined />}
          >
            More Info
          </Button>
      }
    </Tooltip>
  )
}

export default MoreInfoButton